import React, { useReducer } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

/*::
type Props = {
  children: any,
  className?: string,
  small?: boolean,
  title?: any,
}
*/
function Accordion(props) {
  const [contentVisible, toggleContentVisibility] = useReducer(
    state => !state,
    true,
  );

  const { className, fullWidth, small, whiteBackground, contentClassName } =
    props;
  const hasClassName = !!className;
  const accordionStyles = classNames('Accordion', {
    'Accordion--fullWidth': fullWidth,
    'Accordion--small': small,
    [className]: hasClassName,
  });
  const rotatingIconStyles = classNames('Accordion-rotatingIcon', {
    'Accordion-rotatingIcon--rotated': contentVisible,
  });
  const clickableAreaStyles = classNames('Accordion-clickableArea', {
    'Accordion-clickableArea--open': contentVisible,
  });
  const accordionFocusStyles = classNames('Accordion-focus', {
    'Accordion-focus--white': whiteBackground,
  });

  return (
    <div className={accordionStyles}>
      <div className={accordionFocusStyles}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div className={clickableAreaStyles} onClick={toggleContentVisibility}>
          <Text
            data-test-id="accordion-title"
            variant={TEXT_VARIANTS.BODY_BOLD}
          >
            {props.title}
          </Text>
          <span className={rotatingIconStyles}>
            <Icon stabilize={false} name="triangle_down" />
          </span>
        </div>
        <div
          className={classNames({ 'd-n': !contentVisible }, contentClassName)}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
}

export default Accordion;
